import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

// Server-side oauth-callback redirects here with ?connected=<platform>&username=<...>
// (or ?error=...). We wait for the auth context to confirm the user is signed in,
// then forward to /dashboard/platforms with the same params so the Platforms page
// can refetch and toast.

const OAuthComplete: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const connected = searchParams.get('connected');
    const username = searchParams.get('username');
    const error = searchParams.get('error');

    let target = '/dashboard';
    const params = new URLSearchParams();

    if (connected || error) {
      target = '/dashboard/platforms';
      if (connected) params.set('connected', connected);
      if (username) params.set('username', username);
      if (error) params.set('error', error);
    } else {
      const tab = searchParams.get('tab');
      if (tab) target = `/dashboard/${tab}`;
    }

    const qs = params.toString();
    const finalPath = qs ? `${target}?${qs}` : target;
    const t = setTimeout(() => navigate(finalPath, { replace: true }), 800);
    return () => clearTimeout(t);
  }, [user, searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-2">
        <h1 className="text-xl font-semibold">Finishing up…</h1>
        <p className="text-muted-foreground text-sm">Redirecting you back to the dashboard.</p>
      </div>
    </div>
  );
};

export default OAuthComplete;
